import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface PackagerConfigUnsavedChangesProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PackagerConfigUnsavedChanges: React.FC<PackagerConfigUnsavedChangesProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="unsaved-changes-dialog-title"
      data-cy="unsaved-changes-dialog"
    >
      <DialogTitle id="unsaved-changes-dialog-title">Unsaved Changes</DialogTitle>
      <DialogContent>
        <Typography>
          You have unsaved changes. Are you sure you want to close without saving?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-cy="btn-cancel-unsaved-changes">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" data-cy="btn-confirm-unsaved-changes">
          Close Without Saving
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PackagerConfigUnsavedChanges;
